import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DonutKpiDataObject, type DonutKpiState } from '../../types'

const initialState: DonutKpiState = {
  isLoading: true,
  error: false,
  data: undefined,
  httpStatus: 0
}

const lifecycleBreakdownDonutSlice = createSlice({
  name: 'lifecycleBreakdownDonut',
  initialState,
  reducers: {
    lifecycleBreakdownDonutLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    lifecycleBreakdownDonutUpdateAction: (state, action: PayloadAction<{ data: DonutKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    lifecycleBreakdownDonutErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    }
  }
})

export const {
  lifecycleBreakdownDonutLoadingAction,
  lifecycleBreakdownDonutUpdateAction,
  lifecycleBreakdownDonutErrorAction
} = lifecycleBreakdownDonutSlice.actions

export default lifecycleBreakdownDonutSlice.reducer
